import { useEffect, useState } from "react";
import { Trash2, ChevronDown, ChevronUp, Phone, MapPin, Wrench, MessageCircle } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminChats({ authHeaders }) {
  const [chats, setChats] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [onlyLeads, setOnlyLeads] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/chats`, { headers: authHeaders }).then(r => setChats(r.data)).catch(console.error);
  }, [authHeaders]);

  const remove = async (id) => {
    if (!window.confirm("Supprimer cette conversation ?")) return;
    await axios.delete(`${API}/admin/chats/${id}`, { headers: authHeaders });
    setChats(c => c.filter(x => x.session_id !== id));
  };

  const list = onlyLeads ? chats.filter(c => c.lead_sent) : chats;

  return (
    <div data-testid="admin-chats">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', marginBottom: '24px' }}>
        <h2 style={{ color: '#fff', fontSize: '24px', fontWeight: 900, fontFamily: "'Cabinet Grotesk', sans-serif", margin: 0 }}>Conversations assistant IA</h2>
        <label style={{ color: '#aaa', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input type="checkbox" checked={onlyLeads} onChange={e => setOnlyLeads(e.target.checked)} data-testid="chats-only-leads" /> Uniquement avec coordonnées ({chats.filter(c => c.lead_sent).length})
        </label>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {list.map(c => (
          <div key={c.session_id} data-testid={`chat-session-${c.session_id}`} style={{ backgroundColor: '#141414', border: `1px solid ${c.lead_sent ? '#8B0000' : '#27272A'}`, borderRadius: '8px', padding: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
              <span style={{ color: '#fff', fontWeight: 700 }}>{c.name || "Visiteur anonyme"}</span>
              {c.work_type && <span style={{ color: '#8B0000', fontSize: '13px', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '4px' }}><Wrench size={12} /> {c.work_type}</span>}
              {c.commune && <span style={{ color: '#aaa', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '4px' }}><MapPin size={12} /> {c.commune}</span>}
              {c.phone && <a href={`tel:${c.phone}`} style={{ color: '#fff', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '4px', textDecoration: 'none' }}><Phone size={12} /> {c.phone}</a>}
              <span style={{ marginLeft: 'auto', color: '#666', fontSize: '12px' }}>{c.messages.length} msg · {c.last_at ? new Date(c.last_at).toLocaleString('fr-BE') : ""}</span>
              <button onClick={() => setOpenId(openId === c.session_id ? null : c.session_id)} aria-label="Transcription" style={{ background: 'none', border: 'none', color: '#aaa', cursor: 'pointer' }}>{openId === c.session_id ? <ChevronUp size={18} /> : <ChevronDown size={18} />}</button>
              <button onClick={() => remove(c.session_id)} aria-label="Supprimer" style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }}><Trash2 size={16} /></button>
            </div>
            {openId === c.session_id && (
              <div style={{ marginTop: '12px', borderTop: '1px solid #222', paddingTop: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {c.messages.map((m, i) => (
                  <p key={i} style={{ margin: 0, fontSize: '13px', lineHeight: 1.5, color: m.role === "user" ? '#fff' : '#999', paddingLeft: m.role === "user" ? 0 : '16px' }}>
                    <strong style={{ color: m.role === "user" ? '#8B0000' : '#666' }}>{m.role === "user" ? "Visiteur" : "Assistant"} :</strong> {m.content}
                  </p>
                ))}
                {c.phone && <a href={`https://wa.me/${c.phone.replace(/[^0-9]/g, "")}`} target="_blank" rel="noopener noreferrer" style={{ alignSelf: 'flex-start', marginTop: '6px', display: 'inline-flex', alignItems: 'center', gap: '6px', color: '#25D366', fontSize: '13px', fontWeight: 700, textDecoration: 'none' }}><MessageCircle size={14} /> Répondre sur WhatsApp</a>}
              </div>
            )}
          </div>
        ))}
        {list.length === 0 && <p style={{ color: '#666', textAlign: 'center', padding: '40px' }}>Aucune conversation</p>}
      </div>
    </div>
  );
}
